import * as api from './adapter';
import { convertItems, convertItem, convertListOfItems } from './convertors/assignedVessels';

// CREW-1243 — `advertising` is here because the board marks those vessels, and
// this list is the only thing that decides what arrives: a sparse fieldset drops
// everything it does not name. Without it the four real `_AD_…` vessels rendered
// with no marker and the plain tooltip, even though the convertor and the
// component were both ready for the flag.
//
// Worth knowing: `created_at` is NOT here and never was, so the board's old
// `.sort((a, b) => a.createdAt - b.createdAt)` compared `NaN` to `NaN` and left
// the rows in whatever order the API returned them. The order was not "by date
// added" as it appeared — it was unspecified (CREW-1245).
// CREW-1218 — `on_board_count` joins the list for the same reason: the board
// draws the headcount beside the vessel name, and a sparse fieldset drops
// everything it does not name.
const vesselFields = "name,imo,owner_id,owner_name,advertising,on_board_count"

export default {
  index: async (clientId) => {
    const { data } = await api.read('vessels', {
      query: {
        fields: {  vessels: vesselFields },
        include: 'manning_scales',
        filter: { assigned_to: clientId },
        page: { size: 999 },
      },
    });

    return convertItems(data);
  },
  getItems: async ({ vesselId, clientId }) => {
    const { data } = await api.read('assign_vessels', {
      query: (
        vesselId
          ? { include: 'client', filter: { vessel_id: vesselId }, page: { size: 999 } }
          : { include: 'vessel', filter: { client_id: clientId }, page: { size: 999 } }
      ),
    });

    return convertListOfItems(data);
  },
  /**
   * select vessel
   * @param vesselId
   * @param clientId
   * @returns {Promise}
   */
  create: async (vesselId, clientId) => {
    const { data } = await api.create({
      type: 'assign_vessels',
      relationships: {
        vessel: { data: { id: vesselId, type: 'vessels' } },
        client: { data: { id: clientId, type: 'clients' } },
      },
    }, { query: { include: 'client,vessel' } });

    return convertItem(data);
  },
  /**
   * unselect vessel
   * @returns {Promise<*>}
   */
  delete: (id) => api.destroy({ id, type: 'assign_vessels' }),
};
